
  export default {
    mounted() {
      const slot = this.el
      const button = slot.querySelector("button")
      const status = document.getElementById(`${slot.id}-status`)
      let script, timer

      const say = (text, error) => {
        status.textContent = text
        status.classList.toggle("text-error", !!error)
      }

      // Fehlschlag heisst hier: Skript geblockt, Netz weg, oder das Skript lief
      // und hat trotzdem kein iframe hinterlassen. In allen drei Faellen kommt
      // der eigene Knopf zurueck — ein leeres Fach waere eine Sackgasse.
      const failed = () => {
        clearTimeout(timer)
        script?.remove()
        script = null
        slot.removeAttribute("aria-busy")
        button.disabled = false
        button.focus()
        say(slot.dataset.errorText, true)
      }

      const arrived = () => {
        const frame = slot.querySelector("iframe")
        if (!frame) return failed()
        clearTimeout(timer)
        slot.removeAttribute("aria-busy")
        frame.title = slot.dataset.widgetTitle
        // Erst verstecken, wenn der Ersatz steht: sonst ist der Fokus im Nichts.
        button.hidden = true
        say("")
        slot.tabIndex = -1
        slot.focus()
      }

      button.addEventListener("click", () => {
        if (script) return
        button.disabled = true
        slot.setAttribute("aria-busy", "true")
        say(slot.dataset.loadingText)

        // Das Widget-Skript haengt sein iframe dorthin, wo es selbst steht
        // (`document.currentScript`) — auch nachtraeglich eingehaengt.
        script = document.createElement("script")
        script.async = true
        script.src = "https://telegram.org/js/telegram-widget.js?22"
        script.dataset.telegramLogin = slot.dataset.botName
        script.dataset.size = "large"
        script.dataset.radius = "4"
        script.dataset.lang = slot.dataset.lang
        script.dataset.authUrl = slot.dataset.authUrl
        script.dataset.requestAccess = "write"
        script.addEventListener("load", arrived)
        script.addEventListener("error", failed)
        timer = setTimeout(failed, 8000)
        slot.append(script)
      })
    }
  }
